(function () {
  function moneyToNumber(value) {
    var cleaned = String(value || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var parsed = parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(value);
    } catch (error) {
      return 'GBP ' + value.toFixed(2);
    }
  }

  function titleize(value) {
    return String(value || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Treats can carry more than one unit of the same product (a quantity stepper, not a
  // plain toggle) - so repeated entries with the same id + type are consolidated into one
  // "Title x3" line instead of listing the same product three separate times. Toys never
  // has duplicates (plain toggle there), so this is a no-op for it - every count stays 1.
  function describeMultiSelection(items, typeKey) {
    var order = [];
    var byKey = {};
    items.forEach(function (item) {
      var key = item.id + '|' + (item[typeKey] || '');
      if (!byKey[key]) {
        byKey[key] = { typeLabel: titleize(item[typeKey]), title: item.title, qty: 0 };
        order.push(key);
      }
      byKey[key].qty += 1;
    });
    return order
      .map(function (key) {
        var entry = byKey[key];
        var label = [entry.typeLabel, entry.title].filter(Boolean).join(' - ');
        return entry.qty > 1 ? label + ' x' + entry.qty : label;
      })
      .join(', ');
  }

  function Wizard(root) {
    this.root = root;
    this.sequence = [];
    try {
      this.sequence = JSON.parse(root.dataset.stepSequence || '[]');
    } catch (error) {
      this.sequence = ['pet', 'food', 'supplement', 'treats', 'toys', 'frequency', 'membership', 'summary'];
    }
    this.sellingPlanIds = {};
    try {
      this.sellingPlanIds = JSON.parse(root.dataset.sellingPlanIds || '{}');
    } catch (error) {
      this.sellingPlanIds = {};
    }
    this.currentKey = this.sequence[0] || 'pet';
    this.state = {
      healthConcerns: [],
      activeTreatTab: 'freeze-dried',
      isMember: root.dataset.isMember === 'true',
      wantsMembership: undefined,
      treats: [],
      toys: []
    };
    if (this.state.isMember) this.state.wantsMembership = true;

    // Treat categories are admin-configurable (see maxbox-step-treats.liquid), so the
    // default active tab has to come from whatever's actually rendered first, not a
    // hardcoded 'freeze-dried' that might not exist if the admin renamed/reordered them.
    var firstTreatTab = root.querySelector('[data-treat-tab]');
    if (firstTreatTab) this.state.activeTreatTab = firstTreatTab.dataset.treatTab;

    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-wizard-panel]'));
    this.progress = Array.prototype.slice.call(root.querySelectorAll('[data-wizard-progress] [data-step-key]'));
    this.init();
  }

  Wizard.prototype.init = function () {
    this.bindPetStep();
    this.bindHealthConcerns();
    this.bindProductCards();
    this.bindTreatTabs();
    this.bindTreatSteppers();
    this.bindFrequency();
    this.bindMembershipStep();
    this.bindNavigation();
    this.bindSubmit();
    this.renderSavingsBanner();
    this.showStep(this.currentKey, false);
  };

  // Food/Supplement/Treats/Toys are tag-driven per pet type - if a box's catalog simply
  // has no products tagged for the selected species on one of these steps (e.g. a box
  // offers Supplement for dogs but nothing is tagged for cats), that step is skipped
  // automatically rather than forcing the customer through an empty grid. This is purely
  // catalog-driven: there's nothing to configure, just don't tag any products for that
  // species on that step.
  Wizard.prototype.speciesGatedSteps = ['food', 'supplement', 'treats', 'toys'];

  Wizard.prototype.stepHasContent = function (key) {
    if (this.speciesGatedSteps.indexOf(key) === -1) return true;

    // Random-mode Toys has no product picker at all (just an informational note) - that's
    // always "content", regardless of what's tagged for either species.
    if (key === 'toys') {
      var toysPanel = this.root.querySelector('[data-wizard-panel="toys"]');
      if (toysPanel && toysPanel.dataset.toysMode === 'random') return true;
    }

    // Food Series (curated recipe picker) isn't grouped by pet_type at all - it's not
    // tag-driven, so species-gating doesn't apply to it.
    if (key === 'food' && this.root.querySelector('[data-food-group]') === null) return true;

    var petType = this.state.petType || 'dog';
    // Treats cards are data-product-card (quantity stepper), not data-select-product like
    // Food/Supplement/Toys (plain toggle) - matched on data-product-id instead, which both
    // card styles carry.
    var selector = {
      food: '[data-food-group="' + petType + '"] [data-select-product]',
      supplement: '[data-supplement-group="' + petType + '"] [data-select-product]',
      treats: '[data-treat-pet-type="' + petType + '"] [data-product-id]',
      toys: '[data-toy-pet-type="' + petType + '"] [data-select-product]'
    }[key];
    return this.root.querySelector(selector) !== null;
  };

  Wizard.prototype.effectiveSequence = function () {
    return this.sequence.filter(this.stepHasContent, this);
  };

  Wizard.prototype.updateProgressVisibility = function () {
    var effective = this.effectiveSequence();
    this.progress.forEach(function (item) {
      var key = item.dataset.stepKey;
      if (this.speciesGatedSteps.indexOf(key) !== -1) {
        item.hidden = effective.indexOf(key) === -1;
      }
    }, this);
  };

  Wizard.prototype.stepIndex = function (key) {
    return this.effectiveSequence().indexOf(key);
  };

  Wizard.prototype.goNext = function (fromKey) {
    var sequence = this.effectiveSequence();
    var index = sequence.indexOf(fromKey);
    if (index === -1 || index + 1 >= sequence.length) return;
    this.showStep(sequence[index + 1]);
  };

  Wizard.prototype.goBack = function (fromKey) {
    var sequence = this.effectiveSequence();
    var index = sequence.indexOf(fromKey);
    if (index <= 0) return;
    this.showStep(sequence[index - 1]);
  };

  // Shared by an actual click and by the auto-select-if-only-one-option path below, so
  // both end up in the exact same state.
  Wizard.prototype.selectPetType = function (button) {
    this.root.querySelectorAll('[data-pet-type]').forEach(function (item) {
      item.setAttribute('aria-pressed', 'false');
    });
    button.setAttribute('aria-pressed', 'true');
    this.state.petType = button.dataset.petType;
    this.state.healthConcerns = [];
    this.root.querySelectorAll('[data-pet-health-concern]').forEach(function (input) {
      input.checked = false;
    });
    this.updateHealthConcernGroups();
    this.updateFoodGroups();
    this.updateSupplementGroups();
    this.updateTreatGroups();
    this.updateToyGroups();
    this.updateFoodRecommendations();
    this.updateSupplementRecommendations();
    this.updateTreatRecommendations();
    // Treats can be required for one species but optional for the other (data-required-dog/
    // -cat on the panel) - re-decide the skip option and clear any prior skip whenever
    // species changes, so switching from a "not required" species to a "required" one
    // doesn't leave a stale skip in place.
    this.state.treatsSkipped = false;
    this.updateTreatsSkipVisibility();
    this.validateStep('pet');
  };

  Wizard.prototype.isTreatsRequired = function () {
    var panel = this.root.querySelector('[data-wizard-panel="treats"]');
    if (!panel) return true;
    var petType = this.state.petType || 'dog';
    var attr = petType === 'cat' ? panel.dataset.requiredCat : panel.dataset.requiredDog;
    return attr !== 'false';
  };

  Wizard.prototype.updateTreatsSkipVisibility = function () {
    var panel = this.root.querySelector('[data-wizard-panel="treats"]');
    if (!panel) return;
    var skipBtn = panel.querySelector('[data-wizard-skip="treats"]');
    if (skipBtn) skipBtn.hidden = this.isTreatsRequired();
  };

  Wizard.prototype.bindPetStep = function () {
    var self = this;
    var petTypeButtons = this.root.querySelectorAll('[data-pet-type]');
    petTypeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.selectPetType(button);
      });
    });

    // A box can restrict itself to one species (available_pet_types on the Box Builder
    // section) - e.g. MAXBOX Large Breed's 10kg/12kg food tier doesn't apply to cats. When
    // only one pet-type button is rendered at all, there's nothing to choose, so select it
    // immediately instead of making the customer click a foregone conclusion.
    if (petTypeButtons.length === 1) {
      this.selectPetType(petTypeButtons[0]);
    }

    ['petName', 'petBreed', 'petWeight', 'petDob', 'petAge'].forEach(function (field) {
      var selector = '[data-' + field.replace(/[A-Z]/g, function (letter) {
        return '-' + letter.toLowerCase();
      }) + ']';
      var input = self.root.querySelector(selector);
      if (!input) return;
      input.addEventListener('input', function () {
        self.state[field] = input.value;
      });
      input.addEventListener('change', function () {
        self.state[field] = input.value;
      });
    });

    this.root.querySelectorAll('[data-pet-size]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.state.petSize = input.value;
      });
    });
  };

  Wizard.prototype.bindHealthConcerns = function () {
    var self = this;
    this.root.querySelectorAll('[data-pet-health-concern]').forEach(function (input) {
      input.addEventListener('change', function () {
        var species = input.dataset.petHealthConcern;
        self.state.healthConcerns = Array.prototype.slice
          .call(self.root.querySelectorAll('[data-pet-health-concern="' + species + '"]:checked'))
          .map(function (item) {
            return item.value;
          });
        self.updateFoodRecommendations();
        self.updateSupplementRecommendations();
        self.updateTreatRecommendations();
      });
    });
  };

  Wizard.prototype.updateHealthConcernGroups = function () {
    var petType = this.state.petType || 'dog';
    this.root.querySelectorAll('[data-health-group]').forEach(function (group) {
      group.hidden = group.dataset.healthGroup !== petType;
    });
  };

  Wizard.prototype.bindProductCards = function () {
    var self = this;
    this.root.querySelectorAll('[data-select-product]').forEach(function (button) {
      button.addEventListener('click', function () {
        var field = button.dataset.field;
        var panel = button.closest('[data-wizard-panel]');
        var isMulti = button.hasAttribute('data-multi');

        if (isMulti) {
          self.toggleMultiSelection(field, button, panel);
        } else {
          panel.querySelectorAll('[data-select-product][data-field="' + field + '"]').forEach(function (item) {
            item.setAttribute('aria-pressed', 'false');
          });
          button.setAttribute('aria-pressed', 'true');

          self.state[field] = {
            id: button.dataset.productId,
            title: button.dataset.productTitle,
            priceText: button.dataset.productPrice,
            price: moneyToNumber(button.dataset.productPrice),
            memberPrice: button.dataset.memberPrice ? moneyToNumber(button.dataset.memberPrice) : null,
            isSeries: button.dataset.isSeries === 'true',
            treatType: button.dataset.treatType || '',
            toyType: button.dataset.toyType || ''
          };
        }

        self.validateStep(panel.dataset.wizardPanel);
        self.renderSavingsBanner();
      });
    });
  };

  // Multi-select fields (treat, toy) accumulate into an array up to the panel's required
  // quantity. Clicking a selected card removes it; clicking an unselected card at the cap
  // is a no-op until something is deselected - keeps "exactly N" simple to reason about.
  Wizard.prototype.toggleMultiSelection = function (field, button, panel) {
    var stateKey = field + 's';
    var typeKey = field + 'Type';
    var required = parseInt(panel.dataset.requiredQuantity, 10) || 1;
    var list = this.state[stateKey] || [];
    var productId = button.dataset.productId;
    var existingIndex = list.findIndex(function (item) {
      return item.id === productId;
    });

    if (existingIndex !== -1) {
      list.splice(existingIndex, 1);
      button.setAttribute('aria-pressed', 'false');
    } else {
      if (list.length >= required) return;
      list.push({
        id: productId,
        title: button.dataset.productTitle,
        priceText: button.dataset.productPrice,
        price: moneyToNumber(button.dataset.productPrice)
      });
      list[list.length - 1][typeKey] = button.dataset[field + 'Type'] || '';
      button.setAttribute('aria-pressed', 'true');
    }

    this.state[stateKey] = list;
    if (field === 'toy') this.state.toysSkipped = false;
    this.updateQuantityIndicator(panel, list.length, required);
  };

  Wizard.prototype.updateQuantityIndicator = function (panel, selected, required) {
    var selectedEl = panel.querySelector('[data-quantity-selected]');
    var totalEl = panel.querySelector('[data-quantity-total]');
    if (selectedEl) selectedEl.textContent = selected;
    if (totalEl) totalEl.textContent = required;
  };

  Wizard.prototype.bindTreatTabs = function () {
    var self = this;
    this.root.querySelectorAll('[data-treat-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var type = tab.dataset.treatTab;
        self.root.querySelectorAll('[data-treat-tab]').forEach(function (item) {
          item.classList.toggle('is-active', item === tab);
          item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        });
        self.state.activeTreatTab = type;
        self.updateTreatGroups();
      });
    });
  };

  // Treats allows repeat units of the same product (a quantity stepper on each card),
  // unlike every other multi-select step (Toys) which is a plain one-tap toggle. Each
  // unit is still pushed as its own entry into state.treats - describeMultiSelection()
  // consolidates repeats into "Title x3" for display, so nothing downstream (validation,
  // Summary, cart properties) needed to change shape.
  Wizard.prototype.bindTreatSteppers = function () {
    var self = this;
    var treatsPanel = this.root.querySelector('[data-wizard-panel="treats"]');
    if (!treatsPanel) return;

    treatsPanel.querySelectorAll('[data-qty-increment]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.adjustTreatQuantity(button.closest('[data-product-card]'), 1);
      });
    });
    treatsPanel.querySelectorAll('[data-qty-decrement]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.adjustTreatQuantity(button.closest('[data-product-card]'), -1);
      });
    });
  };

  Wizard.prototype.adjustTreatQuantity = function (card, delta) {
    if (!card) return;
    var panel = card.closest('[data-wizard-panel]');
    var required = parseInt(panel.dataset.requiredQuantity, 10) || 1;
    var productId = card.dataset.productId;
    var list = this.state.treats || [];

    if (delta > 0) {
      if (list.length >= required) return;
      list.push({
        id: productId,
        title: card.dataset.productTitle,
        priceText: card.dataset.productPrice,
        price: moneyToNumber(card.dataset.productPrice),
        treatType: card.dataset.treatType || ''
      });
    } else {
      var lastIndex = -1;
      list.forEach(function (item, index) {
        if (item.id === productId) lastIndex = index;
      });
      if (lastIndex === -1) return;
      list.splice(lastIndex, 1);
    }

    this.state.treats = list;
    if (delta > 0) this.state.treatsSkipped = false;
    this.updateTreatCardQuantities(panel);
    this.updateQuantityIndicator(panel, list.length, required);
    this.validateStep('treats');
  };

  Wizard.prototype.updateTreatCardQuantities = function (panel) {
    var list = this.state.treats || [];
    var required = parseInt(panel.dataset.requiredQuantity, 10) || 1;
    var totalQty = list.length;
    var atCap = totalQty >= required;

    panel.querySelectorAll('[data-product-card][data-field="treat"]').forEach(function (card) {
      var productId = card.dataset.productId;
      var qty = list.filter(function (item) { return item.id === productId; }).length;
      var qtyEl = card.querySelector('[data-qty-value]');
      var decrementBtn = card.querySelector('[data-qty-decrement]');
      var incrementBtn = card.querySelector('[data-qty-increment]');

      if (qtyEl) qtyEl.textContent = qty;
      card.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
      if (decrementBtn) decrementBtn.disabled = qty === 0;
      if (incrementBtn) incrementBtn.disabled = atCap;
    });
  };

  Wizard.prototype.bindFrequency = function () {
    var self = this;
    this.root.querySelectorAll('[data-frequency]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.root.querySelectorAll('[data-frequency]').forEach(function (item) {
          item.setAttribute('aria-pressed', 'false');
        });
        button.setAttribute('aria-pressed', 'true');
        self.state.frequency = button.dataset.frequency;
        self.state.frequencyLabel = button.dataset.frequencyLabel;
        self.validateStep('frequency');
      });
    });
  };

  Wizard.prototype.bindMembershipStep = function () {
    var self = this;
    var joinBtn = this.root.querySelector('[data-membership-join]');
    var skipBtn = this.root.querySelector('[data-membership-skip]');

    if (joinBtn) {
      joinBtn.addEventListener('click', function () {
        self.state.wantsMembership = true;
        joinBtn.setAttribute('aria-pressed', 'true');
        if (skipBtn) skipBtn.setAttribute('aria-pressed', 'false');
        self.renderSavingsBanner();

        // If a membership product is configured, joining just flips this flag - addToCart()
        // bundles the membership product into the same cart request as the box, so the
        // discount applies correctly on this very order instead of requiring a separate
        // purchase first. Only fall back to sending the customer to the membership page
        // (losing their in-progress box) if no membership product is set up yet.
        if (!self.root.dataset.membershipProductVariantId) {
          var membershipUrl = self.root.dataset.membershipPageUrl;
          if (membershipUrl) window.open(membershipUrl, '_blank', 'noopener');
        }

        // Picking either card is the whole step - no separate Next button to press.
        self.goNext('membership');
      });
    }
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        self.state.wantsMembership = false;
        skipBtn.setAttribute('aria-pressed', 'true');
        if (joinBtn) joinBtn.setAttribute('aria-pressed', 'false');
        self.renderSavingsBanner();
        self.goNext('membership');
      });
    }
  };

  Wizard.prototype.bindNavigation = function () {
    var self = this;
    this.root.querySelectorAll('[data-wizard-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.dataset.wizardNext;
        if (self.validateStep(key)) self.goNext(key);
      });
    });

    this.root.querySelectorAll('[data-wizard-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.goBack(button.dataset.wizardBack);
      });
    });

    this.root.querySelectorAll('[data-wizard-goto]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        self.showStep(trigger.dataset.wizardGoto);
      });
    });

    this.root.querySelectorAll('[data-wizard-skip]').forEach(function (button) {
      button.addEventListener('click', function () {
        var field = button.dataset.wizardSkip;
        if (field === 'toys') {
          self.state.toys = [];
          self.state.toysSkipped = true;
          var toysPanel = button.closest('[data-wizard-panel]');
          self.updateQuantityIndicator(toysPanel, 0, parseInt(toysPanel.dataset.requiredQuantity, 10) || 1);
        } else if (field === 'treats') {
          self.state.treats = [];
          self.state.treatsSkipped = true;
          var treatsPanel = button.closest('[data-wizard-panel]');
          self.updateTreatCardQuantities(treatsPanel);
          self.updateQuantityIndicator(treatsPanel, 0, parseInt(treatsPanel.dataset.requiredQuantity, 10) || 1);
        } else {
          self.state[field] = {
            id: '',
            title: 'No supplement',
            priceText: '',
            price: 0
          };
        }
        var panel = button.closest('[data-wizard-panel]');
        self.goNext(panel.dataset.wizardPanel);
      });
    });
  };

  Wizard.prototype.bindSubmit = function () {
    var self = this;
    var submit = this.root.querySelector('[data-wizard-submit]');
    if (!submit) return;

    submit.addEventListener('click', function () {
      self.addToCart(submit);
    });
  };

  Wizard.prototype.showStep = function (key, scrollToTop) {
    this.currentKey = key;
    this.panels.forEach(function (panel) {
      var isActive = panel.dataset.wizardPanel === key;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    // Steps are toggled via [hidden], not real page navigation, so the browser keeps
    // whatever scroll position it had on the old panel - which can land anywhere on the
    // new one (often near the bottom, since content height differs between steps). Scroll
    // back to the top of the wizard on every real step change so mobile customers aren't
    // dropped mid-page. Skipped only on the very first render (initial page load).
    if (scrollToTop !== false && typeof window !== 'undefined' && window.scrollTo) {
      var prefersReducedMotion = typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }

    this.updateProgressVisibility();
    var currentIndex = this.stepIndex(key);
    this.progress.forEach(function (item) {
      item.classList.toggle('is-active', item.dataset.stepKey === key);
      item.classList.toggle('is-complete', this.stepIndex(item.dataset.stepKey) < currentIndex);
    }, this);

    if (key === 'food') {
      this.updateFoodGroups();
      this.updateFoodRecommendations();
    }
    if (key === 'supplement') {
      this.updateSupplementGroups();
      this.updateSupplementRecommendations();
    }
    if (key === 'treats') {
      this.updateTreatGroups();
      this.updateTreatRecommendations();
      this.updateTreatCardQuantities(this.root.querySelector('[data-wizard-panel="treats"]'));
      this.updateTreatsSkipVisibility();
    }
    if (key === 'toys') this.updateToyGroups();
    if (key === 'membership') this.updateMembershipUI();
    if (key === 'summary') this.renderSummary();
  };

  Wizard.prototype.validateStep = function (key) {
    var valid = true;
    if (key === 'pet') valid = Boolean(this.state.petType);
    if (key === 'food') valid = Boolean(this.state.food && this.state.food.id);
    if (key === 'supplement') valid = Boolean(this.state.supplement);
    if (key === 'treats') {
      if (this.state.treatsSkipped) {
        valid = true;
      } else {
        var treatsPanel = this.root.querySelector('[data-wizard-panel="treats"]');
        var treatsRequired = treatsPanel ? parseInt(treatsPanel.dataset.requiredQuantity, 10) || 1 : 1;
        valid = this.state.treats.length === treatsRequired;
      }
    }
    if (key === 'toys') {
      var toysPanel = this.root.querySelector('[data-wizard-panel="toys"]');
      if (toysPanel && toysPanel.dataset.toysMode === 'random') {
        valid = true;
      } else if (this.state.toysSkipped) {
        valid = true;
      } else {
        var toysRequired = toysPanel ? parseInt(toysPanel.dataset.requiredQuantity, 10) || 1 : 1;
        valid = this.state.toys.length === toysRequired;
      }
    }
    if (key === 'frequency') valid = Boolean(this.state.frequency);
    if (key === 'membership') valid = this.state.isMember || typeof this.state.wantsMembership === 'boolean';

    var next = this.root.querySelector('[data-wizard-next="' + key + '"]');
    if (next) next.disabled = !valid;
    return valid;
  };

  Wizard.prototype.updateFoodGroups = function () {
    var petType = this.state.petType || 'dog';
    this.root.querySelectorAll('[data-food-group]').forEach(function (group) {
      group.hidden = group.dataset.foodGroup !== petType;
    });
  };

  Wizard.prototype.updateSupplementGroups = function () {
    var petType = this.state.petType || 'dog';
    this.root.querySelectorAll('[data-supplement-group]').forEach(function (group) {
      group.hidden = group.dataset.supplementGroup !== petType;
    });
  };

  Wizard.prototype.updateTreatGroups = function () {
    var petType = this.state.petType || 'dog';
    var activeTab = this.state.activeTreatTab || 'freeze-dried';
    this.root.querySelectorAll('[data-treat-group]').forEach(function (group) {
      group.hidden = group.dataset.treatGroup !== activeTab || group.dataset.treatPetType !== petType;
    });
  };

  Wizard.prototype.updateToyGroups = function () {
    var petType = this.state.petType || 'dog';
    this.root.querySelectorAll('[data-toy-group]').forEach(function (group) {
      group.hidden = group.dataset.toyPetType !== petType;
    });
  };

  Wizard.prototype.recommendedTags = function () {
    return (this.state.healthConcerns || []).map(function (concern) {
      return 'health_concern-' + concern;
    });
  };

  Wizard.prototype.applyRecommendedBadges = function (fieldName, noteSelector) {
    var recommended = this.recommendedTags();
    var anyRecommended = false;
    var groups = [];

    this.root.querySelectorAll('[data-field="' + fieldName + '"]').forEach(function (card) {
      var tags = (card.dataset.healthTags || '').split(',').filter(Boolean);
      var isRecommended = recommended.length > 0 && tags.some(function (tag) {
        return recommended.indexOf(tag) !== -1;
      });
      var badge = card.querySelector('[data-recommended-badge]');
      if (badge) badge.hidden = !isRecommended;
      card.classList.toggle('is-recommended', isRecommended);
      if (isRecommended) anyRecommended = true;
      if (groups.indexOf(card.parentNode) === -1) groups.push(card.parentNode);
    });

    // Recommended items float to the front of each grid so a long catalog doesn't bury
    // them - within "recommended" and "not recommended" the original order is preserved
    // (Array.prototype.sort is stable), just grouped by parent so pet-type/tab grids don't
    // get mixed together.
    if (recommended.length > 0) {
      groups.forEach(function (parent) {
        var cards = Array.prototype.slice.call(parent.querySelectorAll('[data-field="' + fieldName + '"]'));
        cards
          .sort(function (a, b) {
            var aRec = a.classList.contains('is-recommended') ? 0 : 1;
            var bRec = b.classList.contains('is-recommended') ? 0 : 1;
            return aRec - bRec;
          })
          .forEach(function (card) {
            parent.appendChild(card);
          });
      });
    }

    var note = this.root.querySelector(noteSelector);
    if (note) note.hidden = !anyRecommended;
  };

  Wizard.prototype.updateFoodRecommendations = function () {
    this.applyRecommendedBadges('food', '[data-food-recommend-note]');
  };

  Wizard.prototype.updateSupplementRecommendations = function () {
    this.applyRecommendedBadges('supplement', '[data-supplement-recommend-note]');
  };

  Wizard.prototype.updateTreatRecommendations = function () {
    this.applyRecommendedBadges('treat', '[data-treats-recommend-note]');
  };

  // Fixed box pricing: a MAX Box Food Series selection carries its own non-member/member
  // price (read off the matched real variant + the configured series member price). Every
  // other box (including plain tag-driven Food) just uses the section-level non-member/
  // member price. Nothing else selected in the wizard changes the total - see CLAUDE.md
  // "Pricing logic" for why.
  Wizard.prototype.getBoxPricing = function () {
    if (this.state.food && this.state.food.isSeries && this.state.food.memberPrice != null) {
      return {
        nonMember: this.state.food.price,
        member: this.state.food.memberPrice
      };
    }
    return {
      nonMember: moneyToNumber(this.root.dataset.nonMemberPrice),
      member: moneyToNumber(this.root.dataset.memberPrice)
    };
  };

  Wizard.prototype.renderSavingsBanner = function () {
    var banner = this.root.querySelector('[data-savings-banner]');
    if (!banner) return;

    var pricing = this.getBoxPricing();
    if (!pricing.member) {
      banner.hidden = true;
      return;
    }

    if (this.state.isMember) {
      banner.textContent = "You're a MaxBox Member — member pricing is already applied to this box.";
    } else {
      banner.textContent = 'Members pay ' + formatMoney(pricing.member) + ' — you\'re currently on the ' + formatMoney(pricing.nonMember) + ' price.';
    }
    banner.hidden = false;
  };

  Wizard.prototype.updateMembershipUI = function () {
    var pricing = this.getBoxPricing();
    var nonMemberEl = this.root.querySelector('[data-membership-non-member-price]');
    var memberEl = this.root.querySelector('[data-membership-member-price]');
    var savingsEl = this.root.querySelector('[data-membership-savings]');
    var joinLabel = this.root.querySelector('[data-membership-join-label]');

    if (nonMemberEl) nonMemberEl.textContent = formatMoney(pricing.nonMember);
    if (memberEl) memberEl.textContent = formatMoney(pricing.member);

    var savings = Math.max(pricing.nonMember - pricing.member, 0);
    if (savingsEl) savingsEl.textContent = savings ? 'Save ' + formatMoney(savings) : '';
    if (joinLabel) joinLabel.textContent = savings ? 'Join & Save ' + formatMoney(savings) : 'Join MaxBox Membership';

    var joinBtn = this.root.querySelector('[data-membership-join]');
    var skipBtn = this.root.querySelector('[data-membership-skip]');
    if (joinBtn) joinBtn.setAttribute('aria-pressed', String(this.state.wantsMembership === true));
    if (skipBtn) skipBtn.setAttribute('aria-pressed', String(this.state.wantsMembership === false));
  };

  Wizard.prototype.treatsSummaryText = function () {
    if (this.state.treats.length) return describeMultiSelection(this.state.treats, 'treatType');
    return this.state.treatsSkipped ? 'No treats' : 'Not selected';
  };

  Wizard.prototype.toysSummaryText = function () {
    var toysPanel = this.root.querySelector('[data-wizard-panel="toys"]');
    if (toysPanel && toysPanel.dataset.toysMode === 'random') {
      var qty = toysPanel.dataset.requiredQuantity || '1-2';
      return 'Random selection (' + qty + ' included)';
    }
    if (this.state.toys.length) return describeMultiSelection(this.state.toys, 'toyType');
    return this.state.toysSkipped ? 'No toys' : 'Not selected';
  };

  Wizard.prototype.renderSummary = function () {
    var list = this.root.querySelector('[data-summary-list]');
    if (!list) return;

    var pet = titleize(this.state.petType);
    var details = [this.state.petName, this.state.petBreed, titleize(this.state.petAge), titleize(this.state.petSize)]
      .filter(Boolean)
      .join(', ');
    if (details) pet += ' - ' + details;
    if (this.state.petWeight) pet += ' - ' + this.state.petWeight + 'kg';
    if (this.state.petDob) pet += ' - born ' + this.state.petDob;

    var health = (this.state.healthConcerns || []).map(titleize).join(', ') || 'None selected';

    var effective = this.effectiveSequence();
    var rows = [
      ['Pet', pet],
      ['Health Concerns', health]
    ];
    if (effective.indexOf('food') !== -1) {
      rows.push(['Food', this.state.food ? this.state.food.title : 'Not selected']);
    }
    if (effective.indexOf('supplement') !== -1) {
      rows.push(['Supplement', this.state.supplement ? this.state.supplement.title : 'No supplement']);
    }
    if (effective.indexOf('treats') !== -1) {
      rows.push(['Treats', this.treatsSummaryText()]);
    }
    if (effective.indexOf('toys') !== -1) {
      rows.push(['Toys', this.toysSummaryText()]);
    }
    rows.push(['Delivery', this.state.frequencyLabel || 'Not selected']);
    rows.push(['Membership', this.state.isMember ? 'Existing member' : (this.state.wantsMembership ? 'Joining at checkout' : 'Not joining')]);

    list.innerHTML = rows
      .map(function (row) {
        return '<div class="maxbox-wizard-summary__row"><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
      })
      .join('');

    var pricing = this.getBoxPricing();
    var regular = this.root.querySelector('[data-summary-regular-price]');
    var member = this.root.querySelector('[data-summary-member-price]');
    var savingsEl = this.root.querySelector('[data-summary-savings]');
    var joinCta = this.root.querySelector('[data-summary-join-cta]');

    if (regular) regular.textContent = formatMoney(pricing.nonMember);
    if (member) member.textContent = formatMoney(pricing.member);

    var savings = Math.max(pricing.nonMember - pricing.member, 0);
    if (savingsEl) savingsEl.textContent = savings ? 'Save ' + formatMoney(savings) : '';

    if (joinCta) {
      var showCta = !this.state.isMember && this.state.wantsMembership !== true && savings > 0;
      joinCta.hidden = !showCta;
      if (showCta) joinCta.textContent = 'Join & Save ' + formatMoney(savings);
    }
  };

  // Each Frequency option is a separate real Appstle/Shopify selling plan, so the ID to
  // send depends on which Frequency card the customer picked - not a single fixed value.
  Wizard.prototype.getSellingPlanId = function () {
    return this.sellingPlanIds[this.state.frequency] || '';
  };

  Wizard.prototype.addToCart = function (submit) {
    var self = this;
    var error = this.root.querySelector('[data-wizard-error]');
    var variantId = this.root.dataset.boxProductId;
    var sellingPlanId = this.getSellingPlanId();
    var boxType = this.root.dataset.boxType;
    var url = this.root.dataset.cartAddUrl || '/cart/add.js';

    var membershipVariantId = this.root.dataset.membershipProductVariantId;
    var wantsToJoin = Boolean(this.state.wantsMembership && !this.state.isMember && membershipVariantId);

    if (this.state.food && this.state.food.isSeries && this.state.food.id) {
      variantId = this.state.food.id;
    } else if (this.state.wantsMembership && this.root.dataset.memberVariantId) {
      // Swap to the box's member-priced variant whenever member pricing applies - either
      // joining during this order (wantsMembership set by Join & Save) or an existing
      // Member (wantsMembership is forced true for them in the constructor). Previously
      // this required !this.state.isMember, which meant an already-tagged Member's box was
      // silently added at the standard price even though the wizard displayed member
      // pricing throughout - real bug, not intentional.
      variantId = this.root.dataset.memberVariantId;
    }

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    if (!variantId) {
      if (error) {
        error.textContent = 'Choose a box product in the section settings before subscribing.';
        error.hidden = false;
      }
      return;
    }

    // If Appstle is configured for at least one Frequency but not the one the customer
    // actually picked, fail loudly rather than silently checking out as a one-time
    // purchase - that's a misconfiguration (a missing plan ID for this frequency), not a
    // valid "no subscription app yet" state.
    var anyPlanConfigured = Object.keys(this.sellingPlanIds).some(function (key) {
      return Boolean(this.sellingPlanIds[key]);
    }, this);
    if (anyPlanConfigured && !sellingPlanId) {
      if (error) {
        error.textContent = 'This delivery frequency isn\'t connected to a subscription plan yet. Please choose a different frequency or contact us.';
        error.hidden = false;
      }
      return;
    }

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');

    // If joining, check the live cart first for a membership line that's already there
    // (from an earlier box's Join & Save, or added standalone from the membership page) -
    // a second box joining should share that ONE membership, not add a duplicate. Without
    // this, adding two boxes each via Join & Save ended up with two separate membership
    // line items in cart instead of one.
    var findExistingMembership = wantsToJoin
      ? fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var items = (cart && cart.items) || [];
            var existing = null;
            items.forEach(function (cartItem) {
              var props = cartItem.properties || {};
              var isMembershipLine = props['Added via'] === 'Box Builder - Join & Save' ||
                (window.maxboxMembershipProductHandle && cartItem.handle === window.maxboxMembershipProductHandle);
              if (isMembershipLine) existing = cartItem;
            });
            return existing;
          })
          .catch(function () { return null; })
      : Promise.resolve(null);

    findExistingMembership.then(function (existingMembership) {
      var addMembershipItem = wantsToJoin && !existingMembership;
      var bundleId = '';
      if (wantsToJoin) {
        bundleId = (existingMembership && existingMembership.properties && existingMembership.properties['Bundle ID']) ||
          (Date.now().toString(36) + Math.random().toString(36).slice(2, 8));
      }

      var properties = {
        'Box Type': titleize(boxType),
        Pet: [titleize(self.state.petType), self.state.petName, self.state.petBreed, titleize(self.state.petAge), titleize(self.state.petSize)].filter(Boolean).join(' - '),
        'Pet Weight': self.state.petWeight ? self.state.petWeight + ' kg' : '',
        'Pet DOB': self.state.petDob || '',
        'Health Concerns': (self.state.healthConcerns || []).map(titleize).join(', ') || 'None selected',
        Treats: self.treatsSummaryText(),
        Toys: self.toysSummaryText(),
        Frequency: self.state.frequencyLabel || '',
        Membership: self.state.isMember ? 'Existing Member' : (self.state.wantsMembership ? 'Requested at checkout' : 'Not joining')
      };
      // Lets the cart page pair this box up with its membership line item, so removing the
      // membership afterward can cascade-remove the box too instead of leaving it stranded
      // at member pricing with no membership actually in the cart. See maxbox-cart-guard.js.
      if (bundleId) properties['Bundle ID'] = bundleId;
      var effectiveForCart = self.effectiveSequence();
      if (effectiveForCart.indexOf('food') !== -1) {
        properties.Food = self.state.food ? self.state.food.title : '';
      }
      if (effectiveForCart.indexOf('supplement') !== -1) {
        properties.Supplement = self.state.supplement ? self.state.supplement.title : 'No supplement';
      }

      var item = {
        id: Number(variantId),
        quantity: 1,
        properties: properties
      };

      if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

      var items = [item];

      // Bundling the membership product into the same cart request (instead of sending the
      // customer to buy it separately, then coming back) means both purchases land in one
      // order - so the member-priced box variant above is correct immediately, rather than
      // only from the customer's *next* order once Appstle has had a chance to apply the tag.
      if (addMembershipItem) {
        var membershipItem = {
          id: Number(membershipVariantId),
          quantity: 1,
          properties: { 'Added via': 'Box Builder - Join & Save', 'Bundle ID': bundleId }
        };
        // If the membership product is set to "Only sell with these purchase options" in
        // Admin, it can only be added via its real selling plan - without this, the whole
        // cart request gets rejected the moment this line item is included.
        if (window.maxboxMembershipSellingPlanId) {
          membershipItem.selling_plan = Number(window.maxboxMembershipSellingPlanId);
        }
        items.push(membershipItem);
      }

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data && (data.description || data.message) || 'Cart add failed');
            return data;
          });
        })
        .then(function () {
          // Reused an existing membership line that didn't have a Bundle ID yet (e.g. it
          // was added standalone from the membership page, not through a previous box's
          // Join & Save) - stamp it now so this box pairs with it, without ever having
          // added a second membership line item.
          if (wantsToJoin && existingMembership && !(existingMembership.properties && existingMembership.properties['Bundle ID'])) {
            var membershipProperties = Object.assign({}, existingMembership.properties, {
              'Added via': (existingMembership.properties && existingMembership.properties['Added via']) || 'Box Builder - Join & Save',
              'Bundle ID': bundleId
            });
            var changeUrl = (typeof routes !== 'undefined' && routes.cart_change_url) || '/cart/change.js';
            return fetch(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: existingMembership.key, properties: membershipProperties })
            });
          }
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          if (error) {
            error.textContent = (err && err.message) || 'We could not add this box to cart. Please check the box product and selling plan settings.';
            error.hidden = false;
          }
        })
        .finally(function () {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-maxbox-wizard]').forEach(function (root) {
      new Wizard(root);
    });
  });
})();
